import React, { Component } from 'react'
import { Modal, Form, Input, Button, Alert } from 'antd'
import { MagicLinkContextData } from '../../../../../context/MagicLinkContext'
import { isValidURL } from '../../../../../helpers/url-validator'

type MagicLinkProps = {
  visible: boolean
  context: MagicLinkContextData
  onClose: () => void
}

export default class MagicLink extends Component<MagicLinkProps> {

  state = {
    url: '',
    status: 'unset'
  }

  private handleClose = () => {
    this.setState({
      status: 'unset'
    })
    this.props.onClose()
  }

  private handleInputChange = (ev) => {
    this.setState({
      url: ev.target.value
    })
  }

  private handleSave = async () => {
    const { context } = this.props
    const { url } = this.state

    try {
      await context.requestCreateLink({
        url
      })

      this.setState({
        status: 'created'
      })
    } catch (error) {
      this.setState({
        status: 'error'
      })
    }
  }

  private renderFeedback = () => {
    const { context } = this.props
    const { status } = this.state

    if (status === 'created') {
      return (
        <Alert
          message="Success"
          description={`Link created successfully: ${context.urlShortener}`}
          type="success"
          style={{marginBottom: 10}}
          showIcon
        />
      )
    }

    if (status === 'error') {
      return (
        <Alert
          message="Error"
          description={`Could not create the link: Reason: ${context.error.message || context.error}`}
          type="error"
          style={{marginBottom: 10}}
          showIcon
        />
      )
    }
  }

  render() {
    const { visible, context } = this.props
    const { status, url } = this.state

    return (
      <Modal
        title="Magic Link"
        visible={visible}
        onCancel={this.handleClose}
        footer={[
          <Button
            type="primary"
            key="create-link-save"
            loading={!!context.fetching}
            style={{display: status === 'created' ? 'none' : ''}}
            disabled={!isValidURL(url)}
            onClick={this.handleSave}
          >
            Save
          </Button>
        ]}
      >
        {
          this.renderFeedback()
        }

        {
          status !== 'created' && (
            <Form.Item
              label="URL"
            >
              <Input value={url} onChange={this.handleInputChange} />
            </Form.Item>
          )
        }
      </Modal>
    )
  }
}
